<script setup lang="ts">
export interface LabelProps {
  // Clear all class
  raw?: boolean
  // Only using single text
  text?: string
}

const props = defineProps<LabelProps>()

const fieldContext = reactive(
  useFieldContext({
    create: false,
    help: 'Label',
  }),
)

const classes = computed(() => {
  if (props.raw) return []

  return ['label']
})

const onEnter = () => {
  if (fieldContext.id) {
    document.getElementById(fieldContext.id)?.click()
  }
}
</script>

<template>
  <label :class="classes" :for="fieldContext.id" @keydown.enter.prevent="onEnter">
    <slot v-bind="fieldContext"> {{ text }} </slot>
  </label>
</template>
